import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, Button, Form } from "react-bootstrap";
import { useLoader } from '../../_helper/LoaderContext';
import { addMethod, updateMethod } from './service/method-service';
import { toast } from 'react-toastify';

export default function AddMethod({ handleClose, data, getList }) {

    const { t } = useTranslation()
    const [method, setMethod] = useState("");
    const [error, setError] = useState("");
    const { setLoading } = useLoader()

    const handleSubmit = async () => {
        if (!method.trim()) {
            setError(t("Please enter test method"));
            return;
        }

        setLoading(true)
        try {
            if (data) {
                const form_data = new FormData();
                form_data.append("name", method);
                form_data.append("testMethodId", data._id);
                const res = await updateMethod(form_data)
                if (res.data.success == true) {
                    toast.success(res.data.message)
                    getList()
                }
            } else {
                const form_data = new FormData();
                form_data.append("name", method);
                const res = await addMethod(form_data)
                if (res.data.success == true) {
                    toast.success(res.data.message)
                    getList()
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }

        setError("");
        handleClose();
    };

    useEffect(() => {
        if (data) {
            setMethod(data.name)
        }
    }, [data])
    return (
        <>
            {/* <Modal.Header closeButton>
                <Modal.Title>{data ? ` ${t("Edit Test Method")}` : `${t("Add Test Method")}`}</Modal.Title>
            </Modal.Header> */}
            <Modal.Body>
                <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                    <Form.Group controlId="method">
                        <Form.Label>{t("Test Method Name")}
                            <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder={t("Enter test method name")}
                            value={method}
                            onChange={(e) => {
                                setMethod(e.target.value);
                                setError("");
                            }}
                            isInvalid={!!error}
                        />
                        {error && (
                            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
                        )}
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>

                <Button variant="primary" onClick={handleSubmit}>
                    {data ? "Update" : "Create"}
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </>
    )
}
